import { render, staticRenderFns } from "./demand-notice.vue?vue&type=template&id=f49f3e04&"
import script from "./demand-notice.vue?vue&type=script&lang=js&"
export * from "./demand-notice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f49f3e04')) {
      api.createRecord('f49f3e04', component.options)
    } else {
      api.reload('f49f3e04', component.options)
    }
    module.hot.accept("./demand-notice.vue?vue&type=template&id=f49f3e04&", function () {
      api.rerender('f49f3e04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/report/demand-notice.vue"
export default component.exports